import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, UserIcon, ShoppingCartIcon, ChevronDownIcon, LayoutDashboardIcon } from 'lucide-react';
export const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-1159">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-1160">
        <div className="flex items-center space-x-8" data-id="element-1161">
          <Link to="/" className="flex items-center" data-id="element-1162">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tpKLaYzfGrRLG8howg5M89/sellup-logo.png" alt="SellUp Logo" className="h-8" data-id="element-1163" />
          </Link>
          <nav className="hidden md:flex items-center space-x-6" data-id="element-1164">
            <Link to="/category/smart-phones" className="text-gray-700 hover:text-blue-600" data-id="element-1165">
              Smart Phones
            </Link>
            <Link to="/category/tablets" className="text-gray-700 hover:text-blue-600" data-id="element-1166">
              Tablets
            </Link>
            <Link to="/category/laptops" className="text-gray-700 hover:text-blue-600" data-id="element-1167">
              Laptops
            </Link>
            <Link to="/category/smartwatches" className="text-gray-700 hover:text-blue-600" data-id="element-1168">
              Smartwatches
            </Link>
            <div className="relative group" data-id="element-1169">
              <button className="flex items-center text-gray-700 hover:text-blue-600" data-id="element-1170">
                More <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-1171" />
              </button>
              <div className="absolute hidden group-hover:block bg-white shadow-lg rounded-md py-2 w-48 mt-1" data-id="element-1172">
                <Link to="/category/accessories" className="block px-4 py-2 text-gray-700 hover:bg-blue-50" data-id="element-1173">
                  Accessories
                </Link>
                <Link to="/category/audio" className="block px-4 py-2 text-gray-700 hover:bg-blue-50" data-id="element-1174">
                  Audio
                </Link>
                <Link to="/category/gaming" className="block px-4 py-2 text-gray-700 hover:bg-blue-50" data-id="element-1175">
                  Gaming
                </Link>
              </div>
            </div>
            <Link to="/dealers" className="text-gray-700 hover:text-blue-600" data-id="element-1176">
              Dealers
            </Link>
          </nav>
        </div>
        <div className="flex items-center space-x-4" data-id="element-1177">
          <div className="relative w-64 lg:w-80" data-id="element-1178">
            <input type="text" placeholder="What are you looking for" className="w-full py-2 pl-4 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1179" />
            <SearchIcon className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1180" />
          </div>
          <Link to="/trade-in" className="hidden sm:block px-4 py-2 text-blue-600 border border-blue-600 rounded-md hover:bg-blue-50" data-id="element-1181">
            Trade-in
          </Link>
          <Link to="/account" className="p-2 text-gray-700 hover:text-blue-600" data-id="element-1182">
            <UserIcon className="h-6 w-6" data-id="element-1183" />
          </Link>
          <Link to="/cart" className="p-2 text-gray-700 hover:text-blue-600" data-id="element-1184">
            <ShoppingCartIcon className="h-6 w-6" data-id="element-1185" />
          </Link>
          <Link to="/login" className="p-2 text-gray-700 hover:text-blue-600" data-id="element-1186">
            <LayoutDashboardIcon className="h-6 w-6" data-id="element-1187" />
          </Link>
        </div>
      </div>
    </header>;
};